<script setup>
import { inject } from 'vue'

import { PROGRESS_MODULE_VIEW_GRANULATION } from '@/utils/custom-dashboard-helper'
import { currentModuleStateInjectionKey } from '@/utils/injection-keys'
import { useProgressViewPeriods } from '@/utils/progress-view'

import ProgressModuleGridBody from '@/components/dashboard/custom-dashboard/modules/progress-module/ProgressModuleGridBody'
import ProgressModuleGridFooter from '@/components/dashboard/custom-dashboard/modules/progress-module/ProgressModuleGridFooter'
import ProgressModuleGridHeader from '@/components/dashboard/custom-dashboard/modules/progress-module/ProgressModuleGridHeader'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'ProgressModuleGridView'
})

const props = defineProps({
  moduleData: {
    type: Object,
    required: true
  }
})

const { periodsForDisplay, minWidth } = useProgressViewPeriods({
  periods: () => props.moduleData.periods || [],
  granulationId: () => props.moduleData.granulationId
})

const currentModuleState = inject(currentModuleStateInjectionKey, {})
</script>

<template>
  <div
    :class="{
      'pmgv-Wrapper-loading': currentModuleState.isLoading
    }"
    class="pmgv-Wrapper"
  >
    <SkeletonItem
      v-if="currentModuleState.isLoading"
      animation-opacity="0.8"
      class="pmgv-Wrapper_Loader"
      color="transparent"
      height="100%"
      width="100%"
    />
    <ProgressModuleGridHeader :periods="periodsForDisplay" />
    <ProgressModuleGridBody :elements="moduleData.elements" />
    <ProgressModuleGridFooter
      :fill-weekends="moduleData.granulationId === PROGRESS_MODULE_VIEW_GRANULATION.WEEKLY.value"
      :periods="periodsForDisplay"
    />
  </div>
</template>

<style lang="scss" scoped>
.pmgv-Wrapper {
  width: 100%;
  min-width: v-bind('minWidth');
  position: relative;

  &-loading {
    pointer-events: none;
  }
}

.pmgv-Wrapper_Loader {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>
